module.exports = __webpack_public_path__ + "img/MCAST.f8bdd15e.png";